export default "__VITE_ASSET__BBX_lbi5__"